export default __webpack_public_path__ + "static/media/v4.1ff0f19e.jpg";